import { addDays, format } from "date-fns";

import { MergedProduct } from "../queries/data/productData";

import makeSrcWithProtocol from "./makeSrcWithProtocol";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SEOSchemaData = Record<string, any>;

export default function makeProductPageData(
  product: MergedProduct,
  variantId: string
): SEOSchemaData {
  const variant = product.variants.find((v) => v.id === variantId);
  if (!variant) return {};

  const priceValidUntil = format(addDays(new Date(), 30), "yyyy-MM-dd");

  const structuredData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    sku: variant.sku,
    image: variant.images.map((img) => makeSrcWithProtocol(img.url)),
    name: product.title,
    description: product.description,
    productGroupId: product.productType,
    brand: {
      "@type": "Brand",
      name: product.vendor,
    },
    offers: {
      "@type": "Offer",
      price: variant.price,
      priceCurrency: "USD", // TODO: i18n
      availability: variant.available
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
      itemCondition: "https://schema.org/NewCondition",
      priceValidUntil,
    },
    ...(product.rating?.reviewCount && {
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: product.rating?.stars,
        reviewCount: product.rating?.reviewCount,
      },
    }),
  };

  return structuredData;
}
